// src/store/headerSlice.js (Example path)

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userName: null,
  userEmail: null,
  accessToken: null,
  isAuthReady: false, // <-- Add this line
};

const HeaderSlice = createSlice({
  name: "header",
  initialState,
  reducers: {
    setUserInfo: (state, action) => {
      state.userName = action.payload.name;
      state.userEmail = action.payload.email;
      state.accessToken = action.payload.accessToken;
    },
    clearUserInfo: (state) => {
      state.userName = null;
      state.userEmail = null;
      state.accessToken = null;
    },
    // --- Add this new reducer ---
    setAuthReady: (state) => {
      state.isAuthReady = true;
    },
  },
});

// --- Export the new action ---
export const { setUserInfo, clearUserInfo, setAuthReady } = HeaderSlice.actions; 
export default HeaderSlice.reducer;